import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { CardHeader, Avatar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CssBaseline from "@mui/material/CssBaseline";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import { Dashboard } from "@mui/icons-material";

import MuiDrawer from "@mui/material/Drawer";
import { WHITE, ACCENT_BLUE, COLOR_BG } from "../colors";
import {
  CUSTOMER_LIST_PAGE,
  DASHBOARD_PAGE,
  EMPLOYEES_PAGE,
  FINANCIAL_PAGE,
  FORMS_PAGE,
  FORM_EDIT_PAGE,
  FORM_SUBMIT_PAGE,
  DOCUMENTS_PAGE,
  CANDIDATE_PROFILE_CREATION,
  CANDIDATE_PROFILE_CREATION_AI,
  CANDIDATE_SHORT_LIST,
  LEAD_LIST_PAGE,
  JOB_ORDERS_PAGE,
  FRONT_OFFICE_PAGE,
  SYSTEM_CONFIGS_PAGE,
  CVDATA_PAGE,
  INQUIRY_LIST_PAGE,
  CLIENT_PAGE,
  CANDIDATE_PAGE,
  CLIENT_HOME_PAGE
} from "./data";

import { getUserRoutes } from "./NavLinks";
import AppToolBar from "./AppToolBar";

import SideBarBotomImage from "../images/sidebar-bottom.svg";
import BrandImageBanner from "../images/brand.svg";
import BrandNoNameImg from "../images/brand-no-name.svg";

import LayoutBg from "../images/layout-bg.svg";
const drawerWidth = 250;

const BrandDiv = styled("div")(({ theme }) => ({
  ...theme.typography.button,
  color: `${ACCENT_BLUE}`,
  padding: theme.spacing(1),
  textAlign: "cleft",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  // width: `calc(100% - ${drawerWidth}px)`,
  ml: `${drawerWidth}px`,
  boxShadow: "none",
}));
const StyledListText = styled(ListItemText)(({ theme }) => ({
  color: "inherit",
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 10px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 10px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const CustomDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  backgroundColor: `${WHITE}`,
  position: "relative",
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    boxSizing: "border-box",
    backgroundColor: `${WHITE}`,
  },
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function DashboardLayout({ children }) {
  const [openCustomer, setOpenCustomer] = React.useState(false);
  const [NavLinkData, setNavLinkData] = useState([]);
  const [open, setOpen] = React.useState(true);
  const theme = useTheme();
  const history = useHistory();
  const [selected, setSelected] = useState(DASHBOARD_PAGE);
  const location = useLocation();


  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    setOpenCustomer(!openCustomer);
  };

  const user = JSON.parse(localStorage.getItem("user"))?.data;
  useEffect(() => {
    switch (history.location.pathname.split("/")[1]) {
      case "customers":
        setSelected(CUSTOMER_LIST_PAGE);
        break;
      case "dashboard":
        setSelected(DASHBOARD_PAGE);
        break;
      case "users":
        setSelected(EMPLOYEES_PAGE);
        break;
      case "finance":
        setSelected(FINANCIAL_PAGE);
        break;
      case "forms":
        setSelected(FORMS_PAGE);
        break;
      case "form-edits":
        setSelected(FORM_EDIT_PAGE);
        break;
      case "form-submit":
        setSelected(FORM_SUBMIT_PAGE);
        break;
      case "files":
        setSelected(DOCUMENTS_PAGE);
        break;
      case "profile-creation":
        setSelected(CANDIDATE_PROFILE_CREATION);
        break;  
      case "profile-creation-ai":
        setSelected(CANDIDATE_PROFILE_CREATION_AI);
        break;
      case "short-list":
        setSelected(CANDIDATE_SHORT_LIST);
        break;
      case 'leads':
        setSelected(LEAD_LIST_PAGE);
        break;
      case 'job-orders':
        setSelected(JOB_ORDERS_PAGE);
        break;
      case 'front-office':
        setSelected(FRONT_OFFICE_PAGE);
        break;
      case 'system-config':
        setSelected(SYSTEM_CONFIGS_PAGE);
        break;
      case 'cv-data':
        setSelected(CVDATA_PAGE);
        break;
      case 'inquiry-list':
        setSelected(INQUIRY_LIST_PAGE);
        break;
      case 'client-portal':
        setSelected(CLIENT_PAGE);
        break;
      case 'candidate-portal':
        setSelected(CANDIDATE_PAGE);
        break;
      case 'client-home':
        setSelected(CLIENT_HOME_PAGE);
        break;

      default:
        setSelected(DASHBOARD_PAGE);
    }
  }, [location]);

  useEffect(() => {
    setNavLinkData(getUserRoutes(user));
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <StyledAppBar position="fixed" S>
        <AppToolBar selectedPage={selected} />
      </StyledAppBar>
      <CustomDrawer
        variant="permanent"
        open={open}
        anchor="left"
        sx={{
          width: drawerWidth,
          zIndex: 9988,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            backgroundColor: `${WHITE}`,
          },
        }}
      >
       
        <Box
          component="img"
          position="absolute"
          top={10}
          left={0}
          sx={{
            // height: 150,
            width: drawerWidth*0.8,
            margin: "auto",
          }}
          alt="Oseas Powered by Hypen"
          src={open ? BrandImageBanner : BrandNoNameImg}
        />
        <DrawerHeader>
          {!open ? (
            <IconButton sx={{ color: "#fff" }} aria-label="open drawer" onClick={handleDrawerOpen} edge="start">
              <MenuIcon />
            </IconButton>
          ) : (
            <IconButton onClick={handleDrawerClose} sx={{ color: "blue" }}>
              {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          )}
        </DrawerHeader>
     

        {open ? (
          <CardHeader
            sx={{
              zIndex: 9996,
              backgroundColor: `${WHITE}`,
              borderRadius: "10px 10px 0 0",
              mt: 5,
            }}
            avatar={
              <Avatar alt="Remy Sharp" src={user?.profilePic ? user?.profilePic : "/static/images/avatar/1.jpg"} />
            }
            title={user?.name}
            subheader={user?.roleName}
            titleTypographyProps={{ color: "#000", fontSize: 15 }}
          />
        ):(
        <>
         <CardHeader
            sx={{
              zIndex: 9996,
              backgroundColor: `${WHITE}`,
              borderRadius: "10px 10px 0 0",
              mt: 5,
            }}
            avatar={
              <Avatar alt="Remy Sharp" src={user?.profilePic ? user?.profilePic : "/static/images/avatar/1.jpg"} />
            }
            title={user?.name}
            subheader={user?.roleName}
            titleTypographyProps={{ color: "#000", fontSize: 15 }}
          />

          <List sx={{ padding: 1 }}>
          {NavLinkData.map((nav) =>
            nav.sub_links ? (
              <>
                <ListItemButton
                  button
                  sx={{
                    padding: 2,
                    marginBottom: 1,
                    borderRadius: 3,
                    background: nav.name === selected ? `${ACCENT_BLUE}` : WHITE,
                    color: nav.name === selected ? `${WHITE}` : `${ACCENT_BLUE}`,
                    "&:hover": {
                      background: `${ACCENT_BLUE}`,
                      color: `${WHITE}`,
                    },
                  }}
                  key={nav.key}
                  onClick={() => {
                    handleClick();
                    setSelected(nav.name);
                    history.push(nav.link);
                  }}
                >
                  <ListItemIcon sx={{ color: `${WHITE}` }}></ListItemIcon>
                  <StyledListText primary={nav.title} />

                  {openCustomer ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openCustomer} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {nav.sub_links?.map((sub_link) => (
                      <ListItemButton
                        button
                        sx={{
                          pl: 4,
                          ml: 2,
                          padding: 2,
                          marginBottom: 1,
                          borderRadius: 3,
                          background: sub_link.name === selected ? `${ACCENT_BLUE}` : `${WHITE}`,
                          color: sub_link.name === selected ? `${WHITE}` : `${ACCENT_BLUE}`,
                          "&:hover": {
                            background: `${ACCENT_BLUE}`,
                            color: `${WHITE}`,
                          },
                        }}
                        key={sub_link.key}
                        onClick={() => {
                          setSelected(sub_link.name);
                          history.push(sub_link.link);
                        }}
                      >
                        <ListItemIcon sx={{ color: `${WHITE}` }}></ListItemIcon>
                        <StyledListText primary={sub_link.title} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </>
            ) : (
              <ListItem
                button
                sx={{
                  padding: 2,
                  marginBottom: 1,
                  borderRadius: 3,
                  background: nav.name === selected ? `${ACCENT_BLUE}` : `${WHITE}`,
                  color: nav.name === selected ? `${WHITE}` : `${ACCENT_BLUE}`,
                  "&:hover": {
                    background: `${ACCENT_BLUE}`,
                    color: `${WHITE}`,
                  },
                }}
                key={nav.key}
                onClick={() => {
                  setSelected(nav.name);
                  history.push(nav.link);
                }}
              >
                {nav.icon}
              </ListItem>
            )
          )}
          </List>
        </>
        )}

        <Box
          sx={{
            maxHeight: `100vh`,
            height:'100vh',
            overflowY: "scroll",
            backgroundColor: `${WHITE}`,
            zIndex: 9999,
          }}
        >
          {open && (
            <List sx={{ padding: 1 }}>
              {NavLinkData.map((nav) =>
                nav.sub_links ? (
                  <>
                    <ListItemButton
                      button
                      sx={{
                        padding: 2,
                        marginBottom: 1,
                        borderRadius: 3,
                        background: nav.name === selected ? `${ACCENT_BLUE}` : WHITE,
                        color: nav.name === selected ? `${WHITE}` : `${ACCENT_BLUE}`,
                        "&:hover": {
                          background: `${ACCENT_BLUE}`,
                          color: `${WHITE}`,
                        },
                      }}
                      key={nav.key}
                      onClick={() => {
                        handleClick();
                        setSelected(nav.name);
                        history.push(nav.link);
                      }}
                    >
                      <ListItemIcon sx={{ color: `${WHITE}` }}></ListItemIcon>
                      <StyledListText primary={nav.title} />

                      {openCustomer ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openCustomer} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {nav.sub_links?.map((sub_link) => (
                          <ListItemButton
                            button
                            sx={{
                              pl: 4,
                              ml: 2,
                              padding: 2,
                              marginBottom: 1,
                              borderRadius: 3,
                              background: sub_link.name === selected ? `${ACCENT_BLUE}` : `${WHITE}`,
                              color: sub_link.name === selected ? `${WHITE}` : `${ACCENT_BLUE}`,
                              "&:hover": {
                                background: `${ACCENT_BLUE}`,
                                color: `${WHITE}`,
                              },
                            }}
                            key={sub_link.key}
                            onClick={() => {
                              setSelected(sub_link.name);
                              history.push(sub_link.link);
                            }}
                          >
                            <ListItemIcon sx={{ color: `${WHITE}` }}></ListItemIcon>
                            <StyledListText primary={sub_link.title} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  </>
                ) : (
                  <ListItem
                    button
                    sx={{
                      padding: 2,
                      marginBottom: 1,
                      borderRadius: 3,
                      background: nav.name === selected ? `${ACCENT_BLUE}` : `${WHITE}`,
                      color: nav.name === selected ? `${WHITE}` : `${ACCENT_BLUE}`,
                      "&:hover": {
                        background: `${ACCENT_BLUE}`,
                        color: `${WHITE}`,
                      },
                    }}
                    key={nav.key}
                    onClick={() => {
                      setSelected(nav.name);
                      history.push(nav.link);
                    }}
                  >
                    {nav.icon}
                    <StyledListText primary={"   "+ nav.title} />
                  </ListItem>
                )
              )}
            </List>
          )}
        </Box>
      </CustomDrawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundImage: `url(${LayoutBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          height: "100%",
          bgcolor: `${COLOR_BG}`,
          p: 3,
          minHeight: "100vh",
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}
